var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vacancies-list-tab"},[(!_vm.documents.length)?_c('Alert',{attrs:{"text":"Нет прикрепленных вакансий"}}):_c('SubpanelTable',{attrs:{"module":"HRPAC_VACANCY","tableColumns":_vm.columns,"tableData":_vm.documents,"height":_vm.tableHeight.toString()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }